export function normalizeHexColor(input) {
    const raw = input.trim();
    const match = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec(raw);
    if (!match)
        return null;
    let hex = match[1];
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((c) => c + c)
            .join('');
    }
    return `#${hex.toLowerCase()}`;
}
export function parseCssPx(value, fallback = 0) {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : fallback;
}
/** Smaller radius for buttons, channel rows, stat tiles — scales with panel corners. */
export function controlRadiusFromPanel(panelBorderRadius) {
    const px = parseCssPx(panelBorderRadius, 20);
    if (px <= 0)
        return '0px';
    return `${Math.max(4, Math.round(px * 0.5))}px`;
}
export function hexToRgb(hex) {
    const normalized = normalizeHexColor(hex) ?? '#000000';
    const h = normalized.slice(1);
    return {
        r: parseInt(h.slice(0, 2), 16),
        g: parseInt(h.slice(2, 4), 16),
        b: parseInt(h.slice(4, 6), 16),
    };
}
export function rgbToHex({ r, g, b }) {
    const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));
    return `#${[clamp(r), clamp(g), clamp(b)]
        .map((n) => n.toString(16).padStart(2, '0'))
        .join('')}`;
}
export function mixHex(a, b, weightB) {
    const wa = 1 - weightB;
    const ca = hexToRgb(a);
    const cb = hexToRgb(b);
    return rgbToHex({
        r: ca.r * wa + cb.r * weightB,
        g: ca.g * wa + cb.g * weightB,
        b: ca.b * wa + cb.b * weightB,
    });
}
export function lightenHex(hex, amount) {
    return mixHex(hex, '#ffffff', amount);
}
export function darkenHex(hex, amount) {
    return mixHex(hex, '#000000', amount);
}
export function hexAlpha(hex, alpha) {
    const { r, g, b } = hexToRgb(hex);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
//# sourceMappingURL=theme-color-utils.js.map